import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import CustomDate from '../../../../../../../../../../../components/CustomDate'
import Money from '../../../../../../../../../../../components/TableCell/components/Money'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class Table extends Component {
    static propTypes = {
        data: PropTypes.array,
        entityId: PropTypes.string.isRequired,
        handleTableChange: PropTypes.func.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        pagination: PropTypes.object,
        filter: PropTypes.object,
        sorted: PropTypes.array,
        translates: PropTypes.shape({
            inspectionId: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            address: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            inspectionDate: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            sanction: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            ban: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            seizure: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    onTableChange = (changeData) => {
        const { handleTableChange } = this.props

        handleTableChange(changeData)
    }

    getColumnsDefinition = () => {
        const { translates, filter, intl } = this.props

        return [
            {
                accessor: 'inspectionId',
                Header: `${translates.inspectionId}`,
                width: 150,
            },
            {
                accessor: 'addressFull',
                Header: `${translates.address}`,
            },
            {
                accessor: 'startDate',
                Header: `${translates.inspectionDate}`,
                Cell: (value) => (
                    <CustomDate
                        date={_.get(value, 'value.value', '')}
                        precision={_.get(value, 'value.precision', '')}
                    />
                ),
                sortable: true,
                width: 125,
                filterable: true,
                filter: {
                    type: 'VALUE',
                    value: _.map(_.get(filter, 'availableParameters.startDate.availableValues', []), (x) => ({
                        value: _.get(x, 'value', null),
                        item: _.get(x, 'title', null),
                    })),
                },
            },
            {
                accessor: 'sanction',
                Header: `${translates.sanction}`,
                Cell: (value) => <Money value={_.get(value, 'value')} emptyValue={'-'} />,
                sortable: true,
                width: 150,
            },
            {
                accessor: 'seizure',
                Header: `${translates.seizure}`,
                width: 75,
                Cell: ({ value }) =>
                    value ? intl.formatMessage({ id: 'global.yes' }) : intl.formatMessage({ id: 'global.no' }),
            },
            {
                accessor: 'ban',
                Header: `${translates.ban}`,
                width: 75,
                Cell: ({ value }) =>
                    value ? intl.formatMessage({ id: 'global.yes' }) : intl.formatMessage({ id: 'global.no' }),
            },
        ]
    }

    render() {
        const { data, pagination, isLoading, sorted, filter, entityId, intl } = this.props

        return (
            <div className={'inspections-table-container'}>
                <FilterTable
                    id={`inspections-table-${entityId}`}
                    columnsDefinition={this.getColumnsDefinition()}
                    data={data ?? []}
                    onTableChange={this.onTableChange}
                    loading={isLoading}
                    settings={{
                        pagination,
                        sorted,
                        filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                            id: actFilter?.id,
                            value: actFilter?.value || [],
                        })),
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                        filter: {
                            valueTitle: intl.formatMessage({ id: 'global.valueTitle' }),
                            fulltextTitle: intl.formatMessage({ id: 'global.fulltextTitle' }),
                        },
                    }}
                />
            </div>
        )
    }
}
